import Vue from "vue";
import App from "./App.vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import router from "./router";
import store from "./store";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faHome,
  faUsers,
  faCheck,
  faTimes,
  faPen,
  faPlus,
  faSync,
  faFilter,
  faBriefcase,
  faUser,
  faBuilding,
  faBan,
  faToggleOn,
  faToggleOff
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faFileExport } from "@fortawesome/free-solid-svg-icons";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

library.add(faHome);
library.add(faUsers);
library.add(faCheck);
library.add(faTimes);
library.add(faPen);
library.add(faPlus);
library.add(faSync);
library.add(faFilter);
library.add(faFileExport);
library.add(faBriefcase);
library.add(faUser);
library.add(faBuilding);
library.add(faBan);
library.add(faToggleOn);
library.add(faToggleOff);

Vue.component("icon", FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
